
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthFormProvider } from "@/context/auth-form";
import { useAuth } from "@/context/auth";
import AuthContent from "@/components/auth/AuthContent";
import AuthLoadingState from "@/components/auth/AuthLoadingState";
import HomeButton from "@/components/auth/HomeButton";
import { useProtectedRouteRedirect } from "@/hooks/auth/useProtectedRouteRedirect";

const Auth = () => {
  const { user, loading } = useAuth();
  const location = useLocation();
  
  // Handle protected route redirects
  useProtectedRouteRedirect();
  
  // Get current auth mode from URL
  const params = new URLSearchParams(location.search);
  const mode = params.get('mode');
  
  // If authenticated and not in password reset flow, redirect to home
  if (user && !loading && mode !== 'resetPassword') {
    console.log("User authenticated, redirecting...");
    const from = location.state?.from?.pathname || "/";
    return <Navigate to={from} replace />;
  }
  
  // If authentication is still loading, show loading state
  if (loading) {
    return <AuthLoadingState />;
  }
  
  // Check if we should show the home button (only for login and signup modes)
  const shouldShowHomeButton = mode !== 'resetPassword' && mode !== 'forgotPassword';
  
  return (
    <AuthFormProvider>
      <div className="flex min-h-screen flex-col items-center justify-center px-4 py-12 bg-gradient-to-b from-mono-charcoal to-mono-eerieBlack">
        <AuthContent />
        {shouldShowHomeButton && <HomeButton />}
      </div>
    </AuthFormProvider>
  );
};

export default Auth;
